export const Builds = [
  {
    label: 'Small',
    value: 'Small',
  },
  {
    label: 'Medium',
    value: 'Medium',
  },
  {
    label: 'Large',
    value: 'Large',
  },
  {
    label: 'Muscular',
    value: 'Muscular',
  },
];

export const SkinTones = [
  {
    label: 'Light',
    value: 'Light',
  },
  {
    label: 'Medium',
    value: 'Medium',
  },
  {
    label: 'Dark',
    value: 'Dark',
  },
  {
    label: 'Other',
    value: 'Other',
  },
  {
    label: 'Unknown',
    value: 'Unknown',
  },
];

export const Glasses = [
  {
    label: 'Yes',
    value: 'Yes',
  },
  {
    label: 'No',
    value: 'No',
  },
  {
    label: 'Contacts',
    value: 'Contacts',
  },
];

export const EyeDefectsCodes = {
  R: 'Cast, Right Eye',
  L: 'Cast, Left Eye',
  I: 'Right Blind',
  E: 'Left Blind',
  N: 'Nearsighted',
  C: 'Continually Wears Glasses',
  O: 'Occasionally Wears Glasses',
  W: 'Wears Contacts',
  S: 'Cross-Eyed',
  A: 'Left Artificial',
  F: 'Right Artificial',
  M: 'Left Missing',
  G: 'Right Missing',
  NONE: 'None',
} as const;

type EyeDefectCode = keyof typeof EyeDefectsCodes;

export const EyeDefects: Array<{ label: string; value: EyeDefectCode }> = [
  {
    label: 'Cast, Right Eye',
    value: 'R',
  },
  {
    label: 'Cast, Left Eye',
    value: 'L',
  },
  {
    label: 'Right Blind',
    value: 'I',
  },
  {
    label: 'Left Blind',
    value: 'E',
  },
  {
    label: 'Nearsighted',
    value: 'N',
  },
  {
    label: 'Continually Wears Glasses',
    value: 'C',
  },
  {
    label: 'Occasionally Wears Glasses',
    value: 'O',
  },
  {
    label: 'Wears Contacts',
    value: 'W',
  },
  {
    label: 'Cross-Eyed',
    value: 'S',
  },
  {
    label: 'Left Artificial',
    value: 'A',
  },
  {
    label: 'Right Artificial',
    value: 'F',
  },
  {
    label: 'Left Missing',
    value: 'M',
  },
  {
    label: 'Right Missing',
    value: 'G',
  },
  {
    label: 'None',
    value: 'NONE',
  },
];

export const FaceCodes = {
  T: 'Thin',
  M: 'Medium',
  F: 'Full',
} as const;

type FaceCode = keyof typeof FaceCodes;

export const Faces: Array<{ label: string; value: FaceCode }> = [
  {
    label: 'Thin',
    value: 'T',
  },
  {
    label: 'Medium',
    value: 'M',
  },
  {
    label: 'Full',
    value: 'F',
  },
];

export const DisabilitiesCodes = {
  H: 'Hunchback',
  P: 'Plate In Head',
  S: 'Speech / Hearing',
  L: 'Lame / Limp',
  R: 'Right Arm',
  M: 'Left Arm',
  I: 'Right Leg',
  G: 'Left Leg',
  T: 'Right Hand',
  E: 'Left Hand',
  F: 'Left Fingers',
  N: 'Right Fingers',
} as const;

type DisabilityCode = keyof typeof DisabilitiesCodes;

export const Disabilities: Array<{ label: string; value: DisabilityCode }> = [
  {
    label: 'Hunchback',
    value: 'H',
  },
  {
    label: 'Plate In Head',
    value: 'P',
  },
  {
    label: 'Speech / Hearing',
    value: 'S',
  },
  {
    label: 'Lame / Limp',
    value: 'L',
  },
  {
    label: 'Right Arm',
    value: 'R',
  },
  {
    label: 'Left Arm',
    value: 'M',
  },
  {
    label: 'Right Leg',
    value: 'I',
  },
  {
    label: 'Left Leg',
    value: 'G',
  },
  {
    label: 'Right Hand',
    value: 'T',
  },
  {
    label: 'Left Hand',
    value: 'E',
  },
  {
    label: 'Left Fingers',
    value: 'F',
  },
  {
    label: 'Right Fingers',
    value: 'N',
  },
];

export const FacialFeaturesCodes = {
  M: 'Moustache',
  B: 'Beard',
  G: 'Goatee',
  N: 'Clean Shaven',
  C: 'Cleft Chin',
  T: 'Thin Eyebrows',
  E: 'Thick Eyebrows',
  L: 'Thick Lips',
  F: 'Moles On Face',
  Q: 'Chin Protruded',
  R: 'Chin Receded',
  K: 'Thin Lips',
  J: 'Protruding Jaw',
} as const;

type FacialFeatureCode = keyof typeof FacialFeaturesCodes;

export const FacialFeatures: Array<{
  label: string;
  value: FacialFeatureCode;
}> = [
  {
    label: 'Moustache',
    value: 'M',
  },
  {
    label: 'Beard',
    value: 'B',
  },
  {
    label: 'Goatee',
    value: 'G',
  },
  {
    label: 'Clean Shaven',
    value: 'N',
  },
  {
    label: 'Cleft Chin',
    value: 'C',
  },
  {
    label: 'Thin Eyebrows',
    value: 'T',
  },
  {
    label: 'Thick Eyebrows',
    value: 'E',
  },
  {
    label: 'Thick Lips',
    value: 'L',
  },
  {
    label: 'Moles On Face',
    value: 'F',
  },
  {
    label: 'Chin Protruded',
    value: 'Q',
  },
  {
    label: 'Chin Receded',
    value: 'R',
  },
  {
    label: 'Thin Lips',
    value: 'K',
  },
  {
    label: 'Protruding Jaw',
    value: 'J',
  },
];

export const HairTypesCodes = {
  B: 'Bald',
  R: 'Receding',
  C: 'Brush Cut',
  U: 'Curly',
  X: 'Straight',
  W: 'Wavy',
  M: 'Slightly Receding',
  T: 'Wig or Toupee',
  I: 'Side Burns',
  D: 'Dreadlocks',
  S: 'Short',
  V: 'Shaved',
  O: 'Long',
  P: 'Bald Spot',
  E: 'Crew Cut',
  F: 'Afro',
  A: 'Braided',
} as const;

type HairTypeCode = keyof typeof HairTypesCodes;

export const HairTypes: Array<{ label: string; value: HairTypeCode }> = [
  {
    label: 'Bald',
    value: 'B',
  },
  {
    label: 'Receding',
    value: 'R',
  },
  {
    label: 'Brush Cut',
    value: 'C',
  },
  {
    label: 'Curly',
    value: 'U',
  },
  {
    label: 'Straight',
    value: 'X',
  },
  {
    label: 'Wavy',
    value: 'W',
  },
  {
    label: 'Slightly Receding',
    value: 'M',
  },
  {
    label: 'Wig or Toupee',
    value: 'T',
  },
  {
    label: 'Side Burns',
    value: 'I',
  },
  {
    label: 'Dreadlocks',
    value: 'D',
  },
  {
    label: 'Short',
    value: 'S',
  },
  {
    label: 'Shaved',
    value: 'V',
  },
  {
    label: 'Long',
    value: 'O',
  },
  {
    label: 'Bald Spot',
    value: 'P',
  },
  {
    label: 'Crew Cut',
    value: 'E',
  },
  {
    label: 'Afro',
    value: 'F',
  },
  {
    label: 'Braided',
    value: 'A',
  },
];
